<template>
    <b-table 
        :items="tasks" 
        :fields="columns"
        class="table-borderless"
        striped
        small
        show-empty>

        <template slot="creator" slot-scope="row">
            {{ row.item.creator }}
        </template>

        <template slot="creationTime" slot-scope="row">
            {{ $d(row.item.creationTime, "long") }}
        </template>

        <template slot="ccmSfdNumber" slot-scope="row">
            {{ row.item.ccmSfdNumber }}
        </template>

        <template slot="type" slot-scope="row">
            {{ $t(`task.types.${row.item.type}`) }}
        </template>

        <template slot="status" slot-scope="row">
            {{ $t(`task.statuses.${row.item.status}`) }}
        </template>
        
        <template slot="completionTime" slot-scope="row">
            {{ row.item.completionTime 
                ? $d(row.item.completionTime, "long") 
                : $t("task.notCompleted") 
            }}
        </template>

        <template slot="errorMessage" slot-scope="row">
            {{ row.item.errorMessage }}
        </template>

        <template v-if="isTaxpayer || isInspector" slot="action" scope="row">
            <b-link @click="goTo(row.item)" v-b-tooltip :title="getTitle(row.item)" v-if="isPossibleToGoToResult(row.item)">
                {{ $t('general.goTo') }}
            </b-link>
        </template>

        <!-- Show empty row when no task -->
        <template slot="empty">
            <div class="text-center">
                {{ $t('general.noData') }}
            </div>
        </template>

        </b-table>
</template>

<script>
import AppData from '@/utils/appdata';

export default {
    name: 'TaskTable',
    mixins: [AppData],
    props: {
        tasks: Array
    },
    computed: {
        columns() {
            const columns = [
                {key: 'creator', label: this.$t('task.creator'), sortable: true},
                {key: 'creationTime', label: this.$t('task.creationTime'), sortable: true},
                {key: 'ccmSfdNumber', label: this.$t('task.ccmSfdNumber'), sortable: true},
                {key: 'type', label: this.$t('task.type'), sortable: true},

                {key: 'status', label: this.$t('task.status'), sortable: true},
                {key: 'completionTime', label: this.$t('task.completionTime'), sortable: true},
                {key: 'errorMessage', label: this.$t('task.errorMessage'), sortable: false},
            ];

            if (this.isTaxpayer || this.isInspector)
                columns.push({ key: 'action', label: this.$t('general.actions') });
                
            return columns;
        }
    },
    methods: {
        async goTo(item) {
           if (item.status === 'Success' && item.result != null) {
               
               if (item.result.type === 'Report') {
                   const routeName = this.isTaxpayer ? 'reportDetails' : 'childReportDetails';

                   const routeData = this.$router.resolve({ name: routeName, params: { id: item.result.id } });
                   this.openInNewTab(routeData.href);
               }
               else if (item.result.type === 'MoneyPlacement') {
                   const routeName = this.isTaxpayer ? 'moneyPlacementDetails' : 'childMoneyPlacementDetails';
                   const routeData = this.$router.resolve( 
                       { 
                           name: routeName, 
                           params: { id: item.result.id }
                       });
                    
                    this.openInNewTab(routeData.href);
               }
           } 
        },
        openInNewTab(href) {
            window.open(href, '_blank');
        },
        isPossibleToGoToResult(task) {
            return task.status === 'Success' 
                && task.result != null
                && (task.result.type === 'Report' || task.result.type === 'MoneyPlacement'); 
        },
        getTitle(task) {
            if (task.status === 'Success' && task.result != null) {
                if(task.result.type === 'Report')
                    return this.$t('task.goToReport');
                
                if (task.result.type === 'MoneyPlacement'){
                    return task.type === 'WithdrawMoney' 
                        ? this.$t('task.goToWithdrawMoney')
                        : this.$t('task.goToDepositMoney');
                }
            }
        }
    }
}
</script>